import { useState } from "react";
import { useLocation } from "react-router-dom";
import { AppRoutes, Box, Colors, Link, Text, TextVariants } from "reusable";
import "./Footer.css";
import { Appsettings } from "config";
import { InstagramIcon, XIcon, YoutubeIcon } from "./FooterIcons";

const Footer = (): JSX.Element => {
  const path = useLocation().pathname;
  const display = !(
    path === AppRoutes.SIGN_UP ||
    path.includes("fill-details") ||
    path === AppRoutes.LOGIN ||
    path.includes("feedback")
  );

  const [links] = useState<Array<Record<string, string>>>([
    {
      title: "Find a designer",
      to: AppRoutes.EXPLORE_DESIGNERS,
    },
    {
      title: "Create profile",
      to: AppRoutes.FILL_PROFILE_DETAILS,
    },
    {
      title: "FAQ",
      to: AppRoutes.FAQ,
    },
    {
      title: "Blogs",
      to: AppRoutes.BLOGS,
    },
    {
      title: "About us",
      to: AppRoutes.ABOUT_US,
    },
    {
      title: "Contact us",
      to: "https://mail.google.com/mail/?view=cm&fs=1&to=info@kydoscope.com&su=Contact%20from%20Kydoscope%20website",
    },
    {
      title: "Terms of use",
      to: AppRoutes.TERMS_AND_CONDITIONS,
    },
    {
      title: "Privacy policy",
      to: AppRoutes.PRIVACY_POLICY,
    },
  ]);

  return (
    <Box className="footer-component">
      {display && (
        <Box>
          <Box padding="0 75px" className="hide-for-small-only">
            <Box
              id="footer"
              display="flex"
              justifyContent="space-between"
              padding="30px 0"
            >
              <Box>
                {links
                  .filter((_, i) => i < 4)
                  .map((link) =>
                    link.to.startsWith('http') ? (
                      <a
                        key={link.title}
                        href={link.to}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={link.to ? "" : "disabled"}
                      >
                        <Text
                          color={Colors.GRAY_1}
                          variant={TextVariants.MEDIUM_PRIMARY_FONT}
                          marginRight="18px"
                        >
                          {link.title}
                        </Text>
                      </a>
                    ) : (
                      <Link
                        key={link.title}
                        to={link.to}
                        className={link.to ? "" : "disabled"}
                      >
                        <Text
                          color={Colors.GRAY_1}
                          variant={TextVariants.MEDIUM_PRIMARY_FONT}
                          marginRight="18px"
                        >
                          {link.title}
                        </Text>
                      </Link>
                    )
                  )}
              </Box>
              <Box>
                {links
                  .filter((_, i) => i > 3)
                  .map((link) =>
                    link.to.startsWith('http') ? (
                      <a
                        key={link.title}
                        href={link.to}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={link.to ? "" : "disabled"}
                      >
                        <Text
                          color={Colors.GRAY_1}
                          variant={TextVariants.MEDIUM_PRIMARY_FONT}
                          marginRight={link.title !== "Privacy Policy" ? "18px" : ""}
                        >
                          {link.title}
                        </Text>
                      </a>
                    ) : (
                      <Link
                        key={link.title}
                        to={link.to}
                        className={link.to ? "" : "disabled"}
                      >
                        <Text
                          color={Colors.GRAY_1}
                          variant={TextVariants.MEDIUM_PRIMARY_FONT}
                          marginRight={link.title !== "Privacy Policy" ? "18px" : ""}
                        >
                          {link.title}
                        </Text>
                      </Link>
                    )
                  )}
              </Box>
            </Box>
            <Box
              padding="30px 0"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              className="footer-copyright"
            >
              <Box>
                <Text
                  color={Colors.GRAY_1}
                  variant={TextVariants.SMALL_PRIMARY_FONT}
                >
                  © Kydoscope Ventures LLP 2025
                </Text>
              </Box>
              <Box display="flex" alignItems="center" gap="16px">
                <a href="https://www.instagram.com/kydoscope" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><InstagramIcon style={{marginRight:8}} /></a>
                <a href="https://x.com/kydoscope" target="_blank" rel="noopener noreferrer" aria-label="X"><XIcon style={{marginRight:8}} /></a>
                <a href="https://www.youtube.com/@Kydoscope" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><YoutubeIcon style={{marginRight:4}} /></a>
              </Box>
            </Box>
          </Box>
          <Box marginTop="30px" className="show-for-small-only">
            <Box
              display="flex"
              justifyContent="space-around"
              marginBottom="15px"
            >
              {links
                .filter((_, i) => i < 4) // Show first 4 links including Blogs
                .map((link) =>
                  link.to.startsWith('http') ? (
                    <Box key={link.title}>
                      <a
                        href={link.to}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={link.to ? "" : "disabled"}
                      >
                        <Text
                          color={Colors.GRAY_1}
                          variant={TextVariants.MEDIUM_PRIMARY_FONT}
                        >
                          {link.title}
                        </Text>
                      </a>
                    </Box>
                  ) : (
                    <Box key={link.title}>
                      <Link to={link.to} className={link.to ? "" : "disabled"}>
                        <Text
                          color={Colors.GRAY_1}
                          variant={TextVariants.MEDIUM_PRIMARY_FONT}
                        >
                          {link.title}
                        </Text>
                      </Link>
                    </Box>
                  )
                )}
            </Box>
            <Box className="footer-gray-area">
              <Box
                display="flex"
                justifyContent="space-around"
                marginBottom="20px"
              >
                {links
                  .filter((_, i) => i > 3 && i < 8) // This will now start from About Us
                  .map((link) =>
                    link.to.startsWith('http') ? (
                      <Box key={link.title}>
                        <a
                          href={link.to}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={link.to ? "" : "disabled"}
                        >
                          <Text
                            color={Colors.GRAY_1}
                            variant={TextVariants.MEDIUM_PRIMARY_FONT}
                          >
                            {link.title}
                          </Text>
                        </a>
                      </Box>
                    ) : (
                      <Box key={link.title}>
                        <Link to={link.to} className={link.to ? "" : "disabled"}>
                          <Text
                            color={Colors.GRAY_1}
                            variant={TextVariants.MEDIUM_PRIMARY_FONT}
                          >
                            {link.title}
                          </Text>
                        </Link>
                      </Box>
                    )
                  )}
              </Box>
              <Box textAlign="center" width="100%">
                <Text
                  color={Colors.GRAY_1}
                  variant={TextVariants.SMALL_PRIMARY_FONT}
                >
                  Copyright {Appsettings.currentYear} - {Appsettings.appName}
                </Text>
              </Box>
              <Box display="flex" justifyContent="right" alignItems="center" marginTop="12px" width="100%" color="ffffff">
                <a href="https://www.instagram.com/kydoscope" target="_blank" rel="noopener noreferrer" aria-label="Instagram" style={{marginRight: 24}}><InstagramIcon /></a>
                <a href="https://x.com/kydoscope" target="_blank" rel="noopener noreferrer" aria-label="X" style={{marginRight: 24}}><XIcon /></a>
                <a href="https://www.youtube.com/@Kydoscope" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><YoutubeIcon /></a>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Footer;
export { Footer };
